export default __webpack_public_path__ + "3c3fdbad70d55411def05c676c3aa08c.woff2";